<template>
    <div>
        <div class="breadcrumb-layout">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>消息订阅管理</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="tabs-nav">
            <ul class="head">
                <li class="head-item" :class="{'current': subsctOneCheck}" @click="changeStatue(true)">跨机构单条消息订阅</li>
                <li class="head-item" :class="{'current': !subsctOneCheck}" @click="changeStatue(false)" v-if="subscribeMsgsFlag">本机构批量消息订阅</li>
            </ul>
        </div>
        <div v-if="subsctOneCheck">
            <swb-subscr-manage :staffId="thisStaffId" :staffName="thisStaffName"></swb-subscr-manage>
        </div>
        <div v-else-if="subscribeMsgsFlag">
            <swb-subscr-manage-list :staffId="thisStaffId" :staffName="thisStaffName" :comName="thisComName"></swb-subscr-manage-list>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import { openMsgSubscrDlg } from './dialog'
    //
    import bizMsgApi from '../../api/bizMsg'
    import userApi from '../../api/user'
    import merchtComnApi from '../../api/merchtComn'

    // 跨机构单条消息订阅
    import SwbSubscrManage from './SubscrManage'
    Vue.regist(SwbSubscrManage);
    // 本机构批量消息订阅
    import SwbSubscrManageList from './SubscrManageList'
    Vue.regist(SwbSubscrManageList);
    //
    export default {
        name: 'swb-biz-event-msg-subscr-manage',
        path: '/biz/event/msg/subscr/manage',
        desc: ' 消息订阅管理',
        data: function () {
            return {
                thisStaffId: null,
                thisStaffName: null,
                thisComName: null,
                //
                subsctOneCheck: true,
                subscribeMsgsFlag: false
            }
        },
        watch: {
            '$route': 'fetchData'
        },
        created: function () {
            //
            this.fetchData();
        },
        methods: {
            changeStatue: function (subsctOneCheck) {
                //
                this.subsctOneCheck = subsctOneCheck;
            },
            //
            fetchData: function () {    // 监听route变化重新加载界面...
                this.thisStaffId = this.$route.query.staffId || null;
                this.thisStaffName = this.$route.query.staffName || null;
                this.thisComName = this.$route.query.comName || null;
                //
                this.changeStatue(true);
                // 获取批量订阅-业务参数
                this.getMerchtBizParams();
            },
            //
            getMerchtBizParams: function () {
                let self = this;
                let postData = {};
                postData.code = "allow.org.batch.subscribe.msgs";
                merchtComnApi.getMerchantBizParamValue(postData, function (result) {
                    if(result.type === "info") {
                        self.subscribeMsgsFlag = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/bizMsg/SubscrManageMain.vue